/*  MUI  */
import { Box, Checkbox, FormControlLabel } from '@mui/material';

/*  Shared  */
import { SentenceCase } from 'application/Shared/Components/Text';
import { TooltipQ } from 'application/Shared/Components/Tooltips';
import { FontSizes } from 'application/Shared/Constants';

/* NPM */
import { cloneDeep } from 'lodash';

/*  React  */
import React from 'react';
import { useTranslation } from 'react-i18next';

export const ManagedTableToggles = ({
    disabled,
    setPage,
    setSearchText,
    setToggles,
    toggles
}) => {
    const { t } = useTranslation();

    const handleToggleChange = ({ key, checked }) => {
        const currentToggles = cloneDeep(toggles);

        const toggle = { ...toggles[key], enabled: checked };
        currentToggles[key] = toggle;

        setPage(0);
        setSearchText('');
        setToggles(currentToggles);
    };

    return (
        <Box mb="16px">
            {Object.values(toggles).map((singleToggle) => {
                const { key, tooltip, toggleText } = singleToggle;

                return (
                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={!!toggles[key] && toggles[key].enabled}
                                color="primary"
                                disabled={disabled}
                                onChange={(e) =>
                                    handleToggleChange({
                                        checked: e.target.checked,
                                        key
                                    })
                                }
                            />
                        }
                        key={`table_toggle_${key}`}
                        label={
                            <Box display="inline-flex" alignItems="center">
                                <SentenceCase text={toggleText} />
                                {tooltip && (
                                    <TooltipQ
                                        text={t(`Tooltips.${tooltip}`)}
                                        size={FontSizes[1]}
                                    />
                                )}
                            </Box>
                        }
                    />
                );
            })}
        </Box>
    );
};
